export default {
  common: {
    login: "Đăng nhập",
    loginRequired: "Vui lòng đăng nhập để tiếp tục.",
    logout: "Đăng xuất",
    signup: "Đăng ký",
    home: "Trang chủ",
    search: "Tìm kiếm",
    cancel: "Hủy bỏ",
    confirm: "Xác nhận",
    save: "Lưu",
    delete: "Xóa",
    edit: "Chỉnh sửa",
    welcome: "Chào mừng",
    loading: "Đang tải...",
    error: "Đã xảy ra lỗi",
    noData: "Không có dữ liệu",
    number: "STT",
    title: "Tiêu đề",
    date: "Ngày",
    type: "Loại",
    status: "Trạng thái",
    canceled: "Đã hủy",
    approved: "Đã duyệt",
    rejected: "Đã từ chối",
    waiting: "Đang chờ",
    reset: "Đặt lại",
    submit: "Gửi",
    success: "Thành công",
    failed: "Thất bại",
    amountMustBeGreaterThan0: "Số tiền phải lớn hơn 0",
  },
  header: {
    announcement: "Nó đã bắt đầu!",
    login: "Đăng nhập",
    register: "Đăng ký",
    casino: "Sòng bạc Trực tiếp",
    slotGame: "Trò chơi Slot",
    liveSports: "Thể thao Trực tiếp",
    cashIn: "Nạp tiền",
    cashOut: "Rút tiền",
    needHelp: "Cần giúp đỡ",
    honorific: "",
    chip: "Chip",
    point: "Điểm",
    partnerPage: "Trang đối tác",
  },
  slider: {
    casino: {
      subtitle: "SHOGUN LIVE CASINO",
      title1: "Sòng bạc Trực tiếp",
      title2: "Chúng tôi đảm bảo sự hài lòng cho tất cả người chơi",
    },
    slot: {
      subtitle: "SHOGUN SLOT GAME",
      title1: "Slot Trực tiếp",
      title2: "Chúng tôi đảm bảo sự hài lòng cho tất cả người chơi",
    },
    sports: {
      subtitle: "SHOGUN SPORTS",
      title1: "Thể thao Trực tiếp",
      title2: "Chúng tôi đảm bảo sự hài lòng cho tất cả người chơi",
    },
  },
  homePage: {
    casino: {
      title: "Sòng bạc Trực tiếp",
      subtitle: "SHOGUN CASINO",
    },
    slot: {
      title: "Slot",
      subtitle: "SHOGUN SLOT",
    },
  },
  gameList: {
    showAll: "Hiển thị tất cả",
    underMaintenance: "Đang bảo trì.",
  },
  board: {
    faq: {
      subtitle: "CÂU HỎI THƯỜNG GẶP",
      title: "FAQ",
      viewMore: "Xem thêm FAQ",
      items: [
        {
          id: 1,
          title: "'SHOGUN' là công ty như thế nào?",
          content: "'SHOGUN' là nền tảng game toàn cầu cung cấp dịch vụ sòng bạc trực tuyến và di động. Chúng tôi hoạt động 24/7 và cung cấp hơn 100 trò chơi casino khác nhau."
        },
        {
          id: 2,
          title: "Trang web có an toàn không?",
          content: "Vâng, SHOGUN triển khai các hệ thống bảo mật mới nhất để bảo vệ thông tin cá nhân và tài sản của thành viên. Tất cả giao dịch đều được mã hóa và chúng tôi thực hiện kiểm toán định kỳ để đảm bảo môi trường chơi game công bằng."
        },
        {
          id: 3,
          title: "Có nhiều trò chơi không?",
          content: "Vâng, SHOGUN cung cấp hơn 100 trò chơi khác nhau. Bạn có thể tận hưởng nhiều thể loại bao gồm sòng bạc trực tiếp, trò chơi slot và mini game. Đặc biệt trong các trò chơi jackpot tiến trình, bạn có thể giành được giải thưởng lớn."
        },
        {
          id: 4,
          title: "Nạp tiền và rút tiền như thế nào?",
          content: "SHOGUN hỗ trợ nhiều phương thức nạp và rút tiền. Bạn có thể sử dụng chuyển khoản ngân hàng, tiền điện tử (USDT) và các phương thức tiện lợi khác. Nạp tiền được xử lý trong vòng 5-10 phút."
        }
      ]
    },
    notice: {
      subtitle: "THÔNG BÁO",
      title: "Thông báo mới nhất",
      viewMore: "Xem thêm THÔNG BÁO",
    },
  },
  footer: {
    ourPartners: "Đối tác của chúng tôi",
    copyright: "Bản quyền 2024 SHOGUN. Tất cả các quyền được bảo lưu",
    casino: "Sòng bạc Trực tiếp",
    slotGame: "Trò chơi Slot",
    miniGame: "Trò chơi Mini",
  },
  auth: {
    login: "Đăng nhập",
    register: "Đăng ký",
    username: "Tên đăng nhập",
    password: "Mật khẩu",
    passwordConfirm: "Xác nhận mật khẩu",
    passwordMismatch: "Mật khẩu không khớp",
    rememberPassword: "Ghi nhớ mật khẩu",
    captcha: "Vui lòng nhập văn bản CAPTCHA",
    referrer: "Mã giới thiệu",
    phone: "Số điện thoại",
    nameBank: "Tên ngân hàng",
    numberBank: "Số tài khoản",
    userBank: "Chủ tài khoản",
    loginFailed: "Đăng nhập thất bại",
    registerFailed: "Đăng ký thất bại",
  },
  maintenance: {
    title: "Chúng tôi sẽ sớm trở lại!",
    message: "Hệ thống đang bảo trì. Xin lỗi vì sự bất tiện này.",
  },
  homePopup: {
    selectList: "Danh sách chọn",
    deposit: "Nạp tiền",
    withdrawal: "Rút tiền",
    bankingHistory: "Lịch sử giao dịch ngân hàng",
    pointToChip: "Đổi điểm",
    notice: "Thông báo",
    inquiry: "Yêu cầu hỗ trợ",
    myInfo: "Thông tin tài khoản",
    betHistory: "Lịch sử cược",
    faq: "Câu hỏi thường gặp",
  },
  betting: {
    name: "Tên cược",
    game: "Trò chơi",
    type: "Loại",
    amount: "Số tiền",
    date: "Ngày",
    status: {
      win: "THẮNG",
      lose: "THUA",
      bet: "CƯỢC",
    },
  },
  deposit: {
    notice: "Vui lòng kiểm tra kỹ thông tin nạp tiền",
    info: "Nạp tiền sẽ được xử lý trong vòng 5-10 phút",
    currentBalance: "Số Dư Hiện Tại",
    amount: "Số Tiền Nạp",
    usdtAmount: "USDT Nạp Tiền",
    requestAccount: "Yêu Cầu Tài Khoản Nạp Tiền",
    requestUsdtAddress1: "Polygon USDT Address",
    requestUsdtAddress2: "Tron USDT Address",
    myWallet: "Ví của tôi",
    bottomNotice: "Vui lòng liên hệ CSKH nếu cần hỗ trợ",
    title: "Nạp Tiền",
    normalDeposit: "Nạp Tiền Thường",
    usdtDeposit: "Nạp Tiền USDT",
  },
  withdrawal: {
    notice: "Vui lòng kiểm tra kỹ thông tin rút tiền",
    currentBalance: "Số Dư Hiện Tại",
    walletAddress: "Địa chỉ ví",
    amount: "Số Tiền Rút",
    usdtAmount: "USDT Rút Tiền",
    password: "Mật khẩu rút tiền",
    myWallet: "Ví của tôi",
    title: "Rút Tiền",
    normalWithdrawal: "Rút Tiền Thường",
    usdtWithdrawal: "Rút Tiền USDT",
  },
  banking: {
    bankAccountRequired: "Thông tin tài khoản ngân hàng là bắt buộc",
  },
  bankinghistory: {
    beforeBalance: "Số Dư Trước Khi Nạp",
    requestAmount: "Số Tiền Yêu Cầu",
    afterBalance: "Số Dư Sau Khi Nạp",
  },
  profile: {
    username: "Tên người dùng",
    balance: "Số dư",
    point: "Điểm",
    changePassword: "Đổi mật khẩu",
    currentPassword: "Mật khẩu hiện tại",
    newPassword: "Mật khẩu mới",
    confirmPassword: "Xác nhận mật khẩu",
    passwordChanged: "Đổi mật khẩu thành công",
    passwordMismatch: "Mật khẩu không khớp",
    invalidPassword: "Mật khẩu hiện tại không đúng",
  },
  notice: {
    unread: "Chưa đọc",
    read: "Đã đọc",
  },
  inquiry: {
    title: "Tiêu đề",
    select: "Chọn loại yêu cầu",
    writer: "Người gửi",
    placeholder: "Nhập nội dung yêu cầu (tối đa 100 ký tự)",
    types: {
      deposit: "Yêu cầu nạp tiền",
      withdrawal: "Yêu cầu rút tiền",
      account: "Yêu cầu tài khoản nạp tiền",
      other: "Yêu cầu khác",
    },
    question: "Câu hỏi",
    answer: "Trả lời",
    status: "Trạng thái",
    pending: "Đang chờ phản hồi",
    inProgress: "Đang trả lời",
    completed: "Đã trả lời",
    unknown: "Không xác định",
    empty: "Không có câu hỏi nào",
    reply: "Trả lời",
    send: "Gửi",
    note: "Đang chờ phản hồi",
    showMore: "Xem thêm",
    showLess: "Thu gọn",
    newInquiry: "Câu Hỏi Mới",
    delete: "Xóa",
    deleteConfirmation: "Bạn có chắc chắn muốn xóa câu hỏi này không?",
  },
  point: {
    currentBalance: "Điểm hiện tại",
    amount: "Số điểm đổi",
    enterAmount: "Nhập số điểm",
    password: "Mật khẩu",
    enterPassword: "Nhập mật khẩu",
    convert: "Đổi điểm",
    invalidAmount: "Số điểm không hợp lệ",
    convertSuccess: "Đổi điểm thành công",
  },
}; 